import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import ValidatorsGrid from '../components/Grid';
import { ValidatorProvider } from '../store';

import ValidatorFormLayout from './Form';

export default function ValidatorsGridLayout() {
  return <ValidatorProvider>
    <ValidatorsGrid />
    <Router>
      <PrivateRoute path={["/settings/validators/add", "/settings/validators/:id"]} component={ValidatorFormLayout} />
    </Router>
  </ValidatorProvider>;
}
